import { DOCUMENT_TYPES, ROLES } from "../enums/roles.enum";

export const RoleLabels: Record<ROLES, string> = {
  [ROLES.ADMIN]: 'Administrador',
  [ROLES.ASSISTANT]: 'Asistente',
  [ROLES.GUARDIAN]: 'Apoderado',
  [ROLES.TEACHER]: 'Profesor',
  [ROLES.STUDENT]: 'Alumno',
}

export const ROLE_OPTIONS = Object.entries(RoleLabels).map(([value, title]) => ({
  value,
  title,
}))

export const DocumentTypesLabels: Record<DOCUMENT_TYPES, string> = {
  [DOCUMENT_TYPES.DNI]: 'DNI',
  [DOCUMENT_TYPES.CE]: 'Carnet de Extranjería',
  [DOCUMENT_TYPES.PASSPORT]: 'Pasaporte',
}

export const DOCUMENT_TYPES_OPTIONS = Object.entries(DocumentTypesLabels).map(([value, title]) => ({
  value,
  title,
}))